import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { e2p } from "../utils";

interface SongModalProps {
  cover: string;
  title: string;
  artist: string;
  percentage: number;
  onClose: () => void;
}

const SongModal = ({ cover, title, artist, percentage, onClose }: SongModalProps) => {
  const navigate = useNavigate();

  return (
    <div
      onClick={onClose}
      className="fixed inset-0 bg-black/80 flex justify-center items-center !z-[9999]"
    >
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
        transition={{ duration: 0.3 }}
        className="rounded-xl overflow-hidden w-[80%] relative"
      >
        {/* Progress Bar */}
        <div
          dir="ltr"
          className="flex h-10 bg-white text-white text-lg font-bold overflow-hidden"
        >
          <div
            style={{ width: `${percentage}%` }}
            className="bg-[#2a95db] flex items-center justify-center rounded-tr-xl transition-all duration-300"
          >
            {e2p(`${Math.floor(percentage)}`)}٪
          </div>

          {percentage < 100 && <div className="bg-white w-[18%] rounded-tr-xl"></div>}
        </div>

        {/* Cover Image */}
        <img src={cover} alt={title} className="w-full h-auto object-cover" />

        {/* Bottom Content */}
        <div
          className="text-white px-4 py-4 flex justify-between items-center text-right"
          style={{
            background: "rgba(0, 0, 0, 0.8)",
          }}
        >
          <div className="flex flex-col">
            <span className="font-bold text-lg">{title}</span>
            <span className="text-sm text-white/70">{artist}</span>
          </div>

          <button
            onClick={() => {
              onClose();
              navigate("/song-details");
            }}
            className="bg-[#f54f02] text-white px-5 py-2 rounded-lg font-bold text-sm hover:bg-orange-600 transition"
          >
            فعال‌سازی
          </button>
        </div>
      </motion.div>
    </div>
  );
};

export default SongModal;
